import type { AiState, AiVerdict, IdeaStatus } from '@shared/types';
import { AI_VERDICT_LABELS, AI_VERDICT_TONES, IDEA_STATUS_LABELS, IDEA_STATUS_TONES } from '@shared/ideaStatus';
import { tagTone } from '@shared/format';
import { Badge, type BadgeTone } from '../../../components/Badge';

/** 创意相关的徽标集合。集中在一处，避免各页面自己拼标签颜色。 */

export function IdeaStatusBadge({ status, className }: { status: IdeaStatus; className?: string }) {
  return (
    <Badge tone={IDEA_STATUS_TONES[status]} className={className}>
      {IDEA_STATUS_LABELS[status]}
    </Badge>
  );
}

const AI_STATE_LABELS: Record<AiState, string> = {
  idle: '未研判',
  queued: '排队中',
  running: '研判中',
  succeeded: '已研判',
  failed: '研判失败',
};

const AI_STATE_TONES: Record<AiState, BadgeTone> = {
  idle: 'neutral',
  queued: 'info',
  running: 'accent',
  succeeded: 'ok',
  failed: 'critical',
};

export function AiStateBadge({ state, className }: { state: AiState; className?: string }) {
  return (
    <Badge tone={AI_STATE_TONES[state]} className={className}>
      {AI_STATE_LABELS[state]}
    </Badge>
  );
}

export function VerdictBadge({ verdict, score }: { verdict: AiVerdict; score?: number }) {
  return (
    <Badge tone={AI_VERDICT_TONES[verdict]} solid={verdict === 'no_go'}>
      {AI_VERDICT_LABELS[verdict]}
      {typeof score === 'number' ? ` · ${score}` : ''}
    </Badge>
  );
}

export function TagList({ tags, className }: { tags: readonly string[]; className?: string }) {
  if (tags.length === 0) return null;
  return (
    <div className={['flex flex-wrap items-center gap-1', className ?? ''].join(' ')}>
      {tags.map((tag) => (
        <Badge key={tag} tone={tagTone(tag)}>
          {tag}
        </Badge>
      ))}
    </div>
  );
}
